import { useCallback, useRef, useState } from 'react';

export const useInlineEdit = ({ initialValue = '', onCommit }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(initialValue);
  const inputRef = useRef(null);
  const draftValueRef = useRef(draftValue);
  const committedRef = useRef(false);
  const onCommitRef = useRef(onCommit);

  onCommitRef.current = onCommit;
  draftValueRef.current = draftValue;

  const startEdit = useCallback((nextValue) => {
    committedRef.current = false;
    const val = nextValue ?? '';
    draftValueRef.current = val;
    setDraftValue(val);
    setIsEditing(true);
  }, []);

  const cancelEdit = useCallback(() => {
    committedRef.current = true;
    setIsEditing(false);
  }, []);

  const commitEdit = useCallback(() => {
    if (committedRef.current) return;
    committedRef.current = true;
    setIsEditing(false);
    onCommitRef.current?.(draftValueRef.current);
  }, []);

  return {
    isEditing,
    draftValue,
    inputRef,
    setDraftValue,
    startEdit,
    cancelEdit,
    commitEdit,
  };
};
